import React from "react";
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import green from '@material-ui/core/colors/green';
import red from '@material-ui/core/colors/red';
import { Divider, Paper } from "@material-ui/core";
import TextField from '@material-ui/core/TextField';
import { createMuiTheme, MuiThemeProvider } from '@material-ui/core/styles';

import ToothCheckbox from '../../../../components/ToothCheckbox';

const theme = createMuiTheme({
    overrides: {
        /*MuiInputBase: {
            root: {
                marginTop: '20px',
            },
            input: {
                paddingTop: '10px',
            }
        },
        MuiFormLabel: {
            root: {
                width: '170px',
            },
        },        
        MuiFormControl: {
            root: {
                marginTop: '16px',
                marginBottom: '8px',
            }
        }*/
        MuiFormControlLabel: {
            root: {
                margin: '0px',
                marginRight: '0px',
            },
            label: {
                margin: '0px',
            },
        },
        MuiIconButton: {
            root: {
                margin: '0px',
                marginRight: '0px',
            },
        }
    }
});

const styles = theme => ({
    root: {
        flexGrow: 1,
        overflow: 'hidden',
    },
    paper: {
        padding: theme.spacing.unit,
        margin: theme.spacing.unit,
    },
    card: {
      minWidth: 275,
    },
    bullet: {
      display: 'inline-block',
      margin: '0 2px',
      transform: 'scale(0.8)',
    },
    title: {
      fontSize: 18,
      fontWeight: 'bold',
    },
    pos: {
      marginBottom: 12,
    },
    group: {
      margin: `${theme.spacing.unit}px 0`,
    },
    formControl: {
        margin: theme.spacing.unit,
    },
    formLabel: {
        textAlign: 'left',
    },
    formInput: {
        padding: 0,
    },
    formExtractions: {
        margin: 0,
        padding: 0,
    },
    greenradio: {
        color: green[600],
        '&$checked': {
            color: green[500],
        },
    },
    redradio: {
        color: red[600],
        '&$checked': {
            color: red[500],
        },
    },
    cbExtroot: {
        //padding: '0px',
        //margin: '0px',
    },
    divider: {
        margin: 16,
    }
});

class ClaimENStep4 extends React.Component {
    state = {
        fp17data: this.props.fp17data,
        pdata: this.props.pdata,
    };

    componentDidMount() {
        //
    }

    handleChange = name => event => {
        //this.setState({ [name]: event.target.value });
        let datatmp = this.state.fp17data;
        datatmp[name] = event.target.value;
        this.setState({fp17data: datatmp});   
    };

    handleCheckChange = name => event => {
        //this.setState({ [name]: event.target.value });
        let value = undefined;

        if (event.target.checked === true)
            value = event.target.value;
        else
            value = undefined;

        let datatmp = this.state.fp17data;
        datatmp[name] = value;
        this.setState({fp17data: datatmp}); 
    };

    handleExtractionChange = (name, selected) => {

        let datatmp = this.state.fp17data;
        let checkedArray = datatmp.extrTeeth;

        let merged = {...checkedArray, ...selected}

        datatmp.extrTeeth = merged;

        //console.log(merged);

        this.setState({fp17data: datatmp});
  
    }

    render() {
        const { classes } = this.props;

        const toothProps = {
            changeHandle: this.handleExtractionChange,
            selectedTeeth: this.state.fp17data.extrTeeth
        }

        return (
        <MuiThemeProvider theme={theme}>
        <div className={classes.root}>
            <Paper className={classes.paper}>
                    <Typography className={classes.title} color="textSecondary" gutterBottom>
                    Part 4 Orthodontic Data Set
                    </Typography>
                    <Grid container spacing={1}>
                        <Grid item xs={6} sm={4} md={2}>
                            <TextField
                                id="ods9412"
                                label="Photographs Taken"
                                value={this.state.fp17data.ods9412}
                                type="number"
                                inputProps={{ min: "0", max: "32", step: "1" }}
                                className={classes.textField}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                margin="normal"
                                fullWidth="true"
                                helperText="Enter no."
                                onChange={this.handleChange('ods9412')}
                            />                      
                        </Grid>                    
                        <Grid item xs={6} sm={4} md={2}>
                            <TextField
                                id="ods9304"
                                label="Radiographs Taken"
                                value={this.state.fp17data.ods9304}
                                type="number"
                                inputProps={{ min: "0", max: "32", step: "1" }}
                                className={classes.textField}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                margin="normal"
                                fullWidth="true"
                                helperText="Enter no."
                                onChange={this.handleChange('ods9304')}
                            />                      
                        </Grid>   
                        <Grid item xs={6} sm={4} md={2}>
                            <FormControl className={classes.formControl} fullWidth={true}>
                                <FormControlLabel
                                    value="y"
                                    id="ods9401"
                                    label="Removable upper appliance"
                                    control={<Checkbox checked={this.state.fp17data.ods9401 === 'y'}/>}
                                    onChange={this.handleCheckChange('ods9401')}
                                />
                            </FormControl>                
                        </Grid>                                     
                        <Grid item xs={6} sm={4} md={2}>
                            <FormControl className={classes.formControl} fullWidth={true}>
                                <FormControlLabel
                                    value="y"
                                    id="ods9402"
                                    label="Removable lower appliance"
                                    control={<Checkbox checked={this.state.fp17data.ods9402 === 'y'}/>}
                                    onChange={this.handleCheckChange('ods9402')}
                                />
                            </FormControl>                
                        </Grid> 
                        <Grid item xs={6} sm={4} md={2}>
                            <FormControl className={classes.formControl} fullWidth={true}>
                                <FormControlLabel
                                    value="y"
                                    id="ods9404"
                                    label="Fixed upper appliance"
                                    control={<Checkbox checked={this.state.fp17data.ods9404 === 'y'}/>}
                                    onChange={this.handleCheckChange('ods9404')}
                                />
                            </FormControl>                
                        </Grid>                                     
                        <Grid item xs={6} sm={4} md={2}>
                            <FormControl className={classes.formControl} fullWidth={true}>
                                <FormControlLabel
                                    value="y"
                                    id="ods9405"
                                    label="Fixed lower appliance"
                                    control={<Checkbox checked={this.state.fp17data.ods9405 === 'y'}/>}
                                    onChange={this.handleCheckChange('ods9405')}
                                />
                            </FormControl>                
                        </Grid>                                     

                        <Grid item xs={6} sm={4} md={2}>
                            <FormControl className={classes.formControl} fullWidth={true}>
                                <FormControlLabel
                                    value="y"
                                    id="ods9403"
                                    label="Functional appliance"
                                    control={<Checkbox checked={this.state.fp17data.ods9403 === 'y'}/>}
                                    onChange={this.handleCheckChange('ods9403')}
                                />
                            </FormControl>                
                        </Grid>                                     
                        <Grid item xs={6} sm={4} md={2}>
                            <FormControl className={classes.formControl} fullWidth={true}>
                                <FormControlLabel
                                    value="y"
                                    id="ods9406"
                                    label="Retainer upper"
                                    control={<Checkbox checked={this.state.fp17data.ods9406 === 'y'}/>}
                                    onChange={this.handleCheckChange('ods9406')}
                                />
                            </FormControl>                
                        </Grid>                                     
                        <Grid item xs={6} sm={4} md={2}>
                            <FormControl className={classes.formControl} fullWidth={true}>
                                <FormControlLabel
                                    value="y"
                                    id="ods9407"
                                    label="Retainer lower"
                                    control={<Checkbox checked={this.state.fp17data.ods9407 === 'y'}/>}
                                    onChange={this.handleCheckChange('ods9407')}
                                />
                            </FormControl>                
                        </Grid>             

                        <Grid item xs={12}>
                            Extractions                
                        </Grid>
                        <Grid item xs={12} sm={1}>
                            Permanent
                        </Grid>
                        <Grid item xs={12} sm={11}>
                            <ToothCheckbox type='A' side='R' label='9' {...toothProps}/>
                            <ToothCheckbox type='A' side='R' label='8' {...toothProps} />
                            <ToothCheckbox type='A' side='R' label='7' {...toothProps} />
                            <ToothCheckbox type='A' side='R' label='6' {...toothProps} />
                            <ToothCheckbox type='A' side='R' label='5' {...toothProps} />
                            <ToothCheckbox type='A' side='R' label='4' {...toothProps} />
                            <ToothCheckbox type='A' side='R' label='3' {...toothProps} />
                            <ToothCheckbox type='A' side='R' label='2' {...toothProps} />
                            <ToothCheckbox type='A' side='R' label='1' {...toothProps} />
                            <ToothCheckbox type='A' side='L' label='1' {...toothProps} />
                            <ToothCheckbox type='A' side='L' label='2' {...toothProps} />
                            <ToothCheckbox type='A' side='L' label='3' {...toothProps} />
                            <ToothCheckbox type='A' side='L' label='4' {...toothProps} />
                            <ToothCheckbox type='A' side='L' label='5' {...toothProps} />
                            <ToothCheckbox type='A' side='L' label='6' {...toothProps} />
                            <ToothCheckbox type='A' side='L' label='7' {...toothProps} />
                            <ToothCheckbox type='A' side='L' label='8' {...toothProps} /> 
                            <ToothCheckbox type='A' side='L' label='9' {...toothProps} />
                        </Grid>   
                        <Grid item xs={12} sm={1}>
                            Deciduous
                        </Grid>
                        <Grid item xs={12} sm={11}>
                            <ToothCheckbox type='C' side='R' label='5' {...toothProps} />
                            <ToothCheckbox type='C' side='R' label='4' {...toothProps} />
                            <ToothCheckbox type='C' side='R' label='3' {...toothProps} />
                            <ToothCheckbox type='C' side='R' label='2' {...toothProps} />
                            <ToothCheckbox type='C' side='R' label='1' {...toothProps} />
                            <ToothCheckbox type='C' side='L' label='1' {...toothProps} />
                            <ToothCheckbox type='C' side='L' label='2' {...toothProps} />
                            <ToothCheckbox type='C' side='L' label='3' {...toothProps} />
                            <ToothCheckbox type='C' side='L' label='4' {...toothProps} />
                            <ToothCheckbox type='C' side='L' label='5' {...toothProps} />
                        </Grid>
                    </Grid>
                    
            </Paper>
        </div>
        </MuiThemeProvider>
        );
    }
}

ClaimENStep4.propTypes = {
    classes: PropTypes.object.isRequired,
  };
  
  export default withStyles(styles)(ClaimENStep4);